import React from 'react';
import { Form, Input, InputNumber, Slider, Select, Button, Card, Typography } from 'antd';

const { Title, Paragraph } = Typography;

const ProcessConfigurator = ({ config, onSubmit }) => {
  const [form] = Form.useForm();

  const renderInput = (input) => {
    switch (input.type) {
      case 'number':
        return (
          <InputNumber
            min={input.min}
            max={input.max}
            step={input.step}
            defaultValue={input.defaultValue}
          />
        );
      case 'slider':
        return (
          <Slider
            min={input.min}
            max={input.max}
            step={input.step}
            defaultValue={input.defaultValue}
          />
        );
      case 'select':
        return (
          <Select defaultValue={input.defaultValue}>
            {input.options && input.options.map(option => (
              <Select.Option key={option.value} value={option.value}>
                {option.label}
              </Select.Option>
            ))}
          </Select>
        );
      default:
        return <Input />;
    }
  };

  return (
    <Card>
      <Title level={3}>{config.name}</Title>
      <Paragraph>{config.description}</Paragraph>
      <Form form={form} onFinish={onSubmit} layout="vertical">
        {config.inputs.map(input => (
          <Form.Item
            key={input.name}
            name={input.name}
            label={input.label}
            initialValue={input.defaultValue}
          >
            {renderInput(input)}
          </Form.Item>
        ))}
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Run Simulation
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default ProcessConfigurator;